import { useEffect } from "react";
import { useAuth } from "@context/shared/AuthContext";
import useWidgetStore from "@stores/client/useWidgetStore";
import useWidgetRolodexStore from "@stores/client/useWidgetRolodexStore";
import useAccreditationWidgetStore from "@stores/client/useAccreditationWidgetStore";

// The home widget caches hold answers made for one reader: content bodies with
// their per-reader embeds, rolodex pages, accreditation counts (or a 403). A
// sign-out reloads the page, but a session expiry or a sign-out in another tab
// keeps the SPA running and the next sign-in can be someone else — so the
// caches are emptied whenever the session ends. Runs from SessionEffects.
export const useWidgetCacheReset = () => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) return;
    useWidgetStore.getState().clearContents();
    useWidgetRolodexStore.setState({ cache: {}, fetchingWidgets: {} });
    useAccreditationWidgetStore.setState({
      counts: null,
      forbidden: false,
      countsFailed: false,
      countsFetchedAt: 0,
    });
  }, [isAuthenticated]);
};
